// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMaximize24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.4997 10.4419C12.2068 10.7348 12.2068 11.2097 12.4997 11.5026C12.7926 11.7954 13.2674 11.7954 13.5603 11.5026L18.5022 6.562V10.0833C18.5022 10.4975 18.838 10.8333 19.2522 10.8333C19.6664 10.8333 20.0022 10.4975 20.0022 10.0833V4.75L19.9982 4.67207L19.9898 4.6137L19.9634 4.51134L19.9283 4.42483L19.8737 4.32995C19.8474 4.29107 19.817 4.25411 19.7825 4.21965L19.7037 4.15097L19.6213 4.09686L19.5504 4.0616L19.4915 4.03898L19.4236 4.01973L19.3036 4.00175L13.9189 4C13.5047 4 13.1689 4.33579 13.1689 4.75L13.1757 4.85177C13.2254 5.21785 13.5392 5.5 13.9189 5.5L17.4412 5.501L12.4997 10.4419ZM11.5026 13.5603C11.7954 13.2674 11.7954 12.7926 11.5026 12.4997C11.2097 12.2068 10.7348 12.2068 10.4419 12.4997L5.5 17.4402V13.9189C5.5 13.5047 5.16421 13.1689 4.75 13.1689C4.33579 13.1689 4 13.5047 4 13.9189V19.2522L4.004 19.3302L4.01242 19.3885L4.03881 19.4909L4.07393 19.5774L4.1285 19.6723C4.15484 19.7112 4.18523 19.7481 4.21969 19.7826L4.29856 19.8513L4.38095 19.9054L4.45186 19.9406L4.51072 19.9632L4.57863 19.9825L4.69858 20.0005L10.0833 20.0022C10.4975 20.0022 10.8333 19.6664 10.8333 19.2522L10.8265 19.1505C10.7768 18.7844 10.463 18.5022 10.0833 18.5022L6.561 18.5012L11.5026 13.5603Z"
				/>
			</Svg>
		);
	}
);
SvgMaximize24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMaximize24;
